export default "__VITE_ASSET__2ed9272d__"